import React, { useEffect, useState } from "react";
import Header from "../../../Componets/Header";
import Loadercomponent from "../../../Componets/Loader";
import { Button } from "antd";
import toast from "react-hot-toast";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { get_customer_ageing_report } from "../../../Controllers/Dashboard/Dashboard";

const CustomerAgeingReport = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);
  const [role, setRole] = useState("");

  const headers = {
    name: "Customer Ageing Summary",
    components: [
      { type: "search", name: "search", placeholder: "Invoice / Customer Code" },
      {
        type: "select",
        name: "payment_status",
        placeholder: "Payment Status",
        options: [
          { label: "Paid", value: "PAID" },
          { label: "Unpaid", value: "UNPAID" },
          { label: "Partial", value: "PARTIAL" },
        ],
      },
      { type: "range", name: "date" },
    ],
  };

  const fetchData = async (filters) => {
    try {
      setLoader(true);
      const res = await get_customer_ageing_report(filters);
      if (res?.status) {
        setBody(res?.data?.reports || []);
        setRole(res?.data?.role);
      } else toast.error(res?.message);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData({});
  }, []);

  const downloadCSV = () => {
    if (!body.length) return toast.error("No data");

    const header = [
      "Invoice",
      "Customer",
      "Total",
      "Paid",
      "Balance",
      "Status",
      "Ageing (Days)",
    ];

    const rows = body.map((r) => [
      r.invoice,
      r.customer?.name,
      r.total,
      r.paid,
      r.balance,
      r.payment_status,
      r.ageing_days,
    ]);

    const csv = [header, ...rows].map((r) => r.join(",")).join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Customer_Ageing_Report.csv";
    link.click();
  };

  const downloadPDF = () => {
    const doc = new jsPDF("landscape");
    autoTable(doc, {
      head: [[
        "Invoice",
        "Customer",
        "Total",
        "Paid",
        "Balance",
        "Status",
        "Ageing (Days)",
      ]],
      body: body.map((r) => [
        r.invoice,
        r.customer?.name,
        r.total,
        r.paid,
        r.balance,
        r.payment_status,
        r.ageing_days,
      ]),
    });
    doc.save("Customer_Ageing_Report.pdf");
  };

  return (
    <Header headers={headers} formdata={fetchData}>
      <Loadercomponent loader={loader}>
        <div className="flex justify-end gap-3 mb-3">
          <Button onClick={downloadCSV} type="primary">
            Download CSV
          </Button>
          <Button onClick={downloadPDF} type="primary">
            Download PDF
          </Button>
        </div>

        <table className="w-full border">
          <thead>
            <tr>
              <th>Invoice</th>
              <th>Customer</th>
              <th>Total</th>
              <th>Paid</th>
              <th>Balance</th>
              <th>Status</th>
              <th>Ageing</th>
            </tr>
          </thead>
          <tbody>
            {body.map((r, i) => (
              <tr key={i}>
                <td>{r.invoice}</td>
                <td>{r.customer?.name}</td>
                <td>{r.total.toFixed(3)}</td>
                <td>{r.paid.toFixed(3)}</td>
                <td>{r.balance.toFixed(3)}</td>
                <td>{r.payment_status}</td>
                <td>{r.ageing_days} days</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Loadercomponent>
    </Header>
  );
};

export default CustomerAgeingReport;
